import React from 'react'

const Footer = () => {
    return(
        <>
            <div className='bg-dark text-light p-4 navbar fixed-bottom '>
                <h6 className='text-center black-text lato'>All rights reseved &copy; Swayam</h6>
            </div>
        </>
    )
}

export default Footer